'use strict';
/* jslint browserify:true, browser:true, devel:true */

import L from 'leaflet';
import { Signal } from 'signals';

import LocationFilter from './locationfilter/LocationFilter.es6';
// import MarkersCanvas from './MarkersCanvas.es6';
import Markers from './MarkersTiledCanvas.es6';
// import Markers from './MarkersTiledCanvasCopy.es6';
// import HeatMap from './heatmap/HeatMap.es6';
// import heatOpts from './heatmap/heatOpts.es6';

class ArchiveMap {

  constructor(lmap, archive, tooltip) {
    this._heatmaps = {};

    this._lmap = lmap;
    this._tooltip = tooltip;
    this.updated = new Signal();

    this._archive = archive;
    this._archive.dataChanged.add(() => this._onDataChanged());
    this._setUp();
    this._onDataChanged();
  }

  getSelectedBounds() {
    const bounds = this._locationFilter.getBounds();
    if (bounds) return bounds;
    return L.latLngBounds(this._archive.bounds);
  }

  _setUp() {
    this._layer = L.layerGroup();
    this._facet = this._archive.getFacet('location');
    this._markers = new Markers(this._lmap, this._layer, { fillColor: '#F83048' });
    this._locationFilter = new LocationFilter(this._lmap);
    this._locationFilter.selectionChanged.add(bounds => this._onLocationFilterChanged(bounds));
    this.show();
  }

  // MODEL EVENT HANDLERS

  _onDataChanged() {
    if (!this._facet) return;
    this._locations = this._facet.groups()
    if (!this._locations) return;

    this._locations.map(loc => {
      loc.lat = parseFloat(loc.lat);
      loc.lng = parseFloat(loc.lng);
      return loc;
    });

    this._tooltip.updateLocations(this._locations);
    this._markers.updateData(this._locations);
    this.updated.dispatch();

    if (this._fitted) return;
    // this._lmap.fitBounds(this._markers.getBounds(), { paddingBottomRight: [525, 0] });
    this._fitted = true;
  }

  // _onCollectionVisibilityChanged(coll, visible) {
  //   const n = coll.name;
  //   if (visible) {
  //     // this._heatmaps[n].show();
  //     this._markers[n].show();
  //     this._tooltip.show(n);
  //   } else {
  //     // this._heatmaps[n].hide();
  //     this._markers[n].hide();
  //     this._tooltip.hide(n);
  //   }
  // }

  // MAP EVENT HANDLERS

  _onLocationFilterChanged(bounds) {
    if (bounds) {
      this._facet.filter([bounds.getSouth(), bounds.getNorth(), bounds.getWest(), bounds.getEast()]);
    } else {
      this._facet.clear();
    }
  }

  // hide() {
  //   this._lmap.removeLayer(this._layer);
  //   this._tooltip.disable();
  // }

  show() {
    this._lmap.addLayer(this._layer);
    this._tooltip.enable();
    // this._lmap.fitBounds(L.latLngBounds(this._archive.bounds), { paddingBottomRight: [525, 0] });
  }

}

ArchiveMap.COLOR_MAP = {
  editore: '#F83048',
  libreria: '#008CD2',
  biblioteca: '#F8AC30',
};

module.exports = ArchiveMap;



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/map/ArchiveMap.es6
 **/